import type { RootState } from '@/store';
import type { AuthState } from '@/store/auth/authSlice';

const defaultAuthState: AuthState = {
  user: null,
  signInError: null,
  signOutError: null,
  isLoading: true
};

export const selectAuthState = (state: RootState): AuthState => state?.auth ?? defaultAuthState;
